import { Link } from 'react-router-dom';
import Breadcrumb from '../../components/feature/Breadcrumb';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { useSEO } from '../../hooks/useSEO';
import { blogPosts } from './posts';

const BlogPage = () => {
  useSEO({
    title: 'ブログ',
    description: '材料レビュー、設定メモ、曲げ試験などの実験記録。',
    keywords: '3Dプリンター,ブログ,フィラメント,曲げ試験,ELEGOO',
    canonicalPath: '/blog'
  });

  const breadcrumbItems = [
    { label: 'ホーム', path: '/' },
    { label: 'ブログ' }
  ];

  return (
    <>
      <Header />
      <div className="min-h-screen bg-graphite mechanical-grid">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <Breadcrumb items={breadcrumbItems} />

          <div className="space-y-8 mt-8">
            <div className="text-center space-y-4 mt-8">
              <h1 className="text-4xl font-bold text-white font-['Exo']">ブログ</h1>
              <p className="text-metal-light text-lg font-['Roboto_Mono']">
                材料レビュー、設定メモ、実験の記録
              </p>
              <div className="section-divider max-w-md mx-auto"></div>
            </div>

            <div className="grid grid-cols-1 gap-6">
              {blogPosts.map((post) => (
                <article key={post.slug} className="clickable-card p-6">
                  <div className="space-y-4">
                    <div className="flex flex-wrap items-center gap-3">
                      <span className="tech-label text-xs">{post.category}</span>
                      <time dateTime={post.date} className="text-metal-light text-sm font-['Roboto_Mono']">
                        {post.date}
                      </time>
                    </div>
                    <Link
                      to={`/blog/${post.slug}`}
                      className="block text-xl font-semibold text-white font-['Exo'] hover:text-accent transition-colors"
                    >
                      {post.title}
                    </Link>
                    <p className="text-metal-light text-sm leading-relaxed">{post.description}</p>
                    <Link
                      to={`/blog/${post.slug}`}
                      className="inline-flex items-center text-accent text-sm font-['Roboto_Mono'] hover:text-white transition-colors"
                    >
                      <span>▶ 記事を読む</span>
                      <i className="ri-arrow-right-line ml-2"></i>
                    </Link>
                  </div>
                </article>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default BlogPage;
